"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.igMMessages = exports.igGMessages = exports.IgM = exports.IgG = void 0;
const schema_1 = require("../../../../schema");
var IgG;
(function (IgG) {
    IgG["POSITIVE"] = "POSITIVE";
    IgG["NEGATIVE"] = "NEGATIVE";
})(IgG || (exports.IgG = IgG = {}));
var IgM;
(function (IgM) {
    IgM["POSITIVE"] = "POSITIVE";
    IgM["NEGATIVE"] = "NEGATIVE";
})(IgM || (exports.IgM = IgM = {}));
exports.igGMessages = {
    [IgG.POSITIVE]: {
        id: "ktx.basicRegistrationData.viralSerology.cmv.igG.POSITIVE",
        defaultMessage: "Pozitív"
    },
    [IgG.NEGATIVE]: {
        id: "ktx.basicRegistrationData.viralSerology.cmv.igG.NEGATIVE",
        defaultMessage: "Negatív"
    }
};
exports.igMMessages = {
    [IgM.POSITIVE]: {
        id: "ktx.basicRegistrationData.viralSerology.cmv.igM.POSITIVE",
        defaultMessage: "Pozitív"
    },
    [IgM.NEGATIVE]: {
        id: "ktx.basicRegistrationData.viralSerology.cmv.igM.NEGATIVE",
        defaultMessage: "Negatív"
    }
};
const igG = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(IgG.POSITIVE),
    schema_1.Schema.singleChoiceItem(IgG.NEGATIVE)
]);
const igM = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(IgM.POSITIVE),
    schema_1.Schema.singleChoiceItem(IgM.NEGATIVE)
]).optional();
exports.validator = schema_1.Schema.object()
    .expiration(31536000)
    .default({})
    .sealed(true)
    .properties({ igG, igM })
    .interpretation({ vocab: "ktx", code: "microbiological_cmv" })
    .tag({ vocab: "snomed", code: "30200007", source: "synonym" })
    .tag({ vocab: "snomed", code: "313604004" })
    .tag({ vocab: "ktx", code: "microbiological_procedure" })
    .tag({ vocab: "snomed", code: "20135006" })
    .tag({ vocab: "snomed", code: "165994006" });
